export const getStorageByKey = key => {
  const value = localStorage.getItem(key);
  if (!value || value === "undefined") return;
  return JSON.parse(value);
};

export const setStorageValueByKey = (key, value) => {
  const item = JSON.stringify(value);
  localStorage.setItem(key, item);
};
